import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';

import { YStack } from '@/components/ui/layout/layout';
import { cn } from '@/lib/utils';
import { uiStore } from '@/stores/ui.store';

import { browserRequestHosts } from './browser-request-presentation';

export const BrowserRequestHost = observer(
  ({
    threadId,
    isCompact = false,
    compactHorizontalPadding = false,
    className,
  }: {
    threadId: string;
    isCompact?: boolean;
    compactHorizontalPadding?: boolean;
    className?: string;
  }) => {
    const registerHost = useCallback(
      (element: HTMLDivElement | null) => {
        runInAction(() => {
          if (element) browserRequestHosts.set(threadId, element);
          else browserRequestHosts.delete(threadId);
        });
      },
      [threadId]
    );

    return (
      <YStack
        className={cn(
          'mx-auto w-full py-4 has-[>:empty]:hidden',
          compactHorizontalPadding
            ? 'px-3'
            : 'px-3 md:px-12 [[data-context-chat]_&]:px-6',
          uiStore.chatWidth,
          className
        )}
      >
        <YStack
          ref={registerHost}
          className={cn('min-w-0 gap-4', isCompact ? 'px-1' : 'px-7')}
          data-testid="inline-browser-request"
        />
      </YStack>
    );
  }
);
